module.exports = __webpack_public_path__ + "img/collage.449e5ee6.png";